"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = getTransitionEnd;

var _getTransitionProperties = _interopRequireDefault(require("./getTransitionProperties"));

function getTransitionEnd() {
  return (0, _getTransitionProperties["default"])().end;
}

module.exports = exports.default;